import { observer } from "mobx-react-lite";
import * as React from "react";
import { BrowserRouter, Link } from "react-router-dom";
import { useAuthStore } from "../hooks/useAuthStore";
import AuthStore from "../store/AuthStore";
import MainApp from "../components/MainApp";
import { IUser } from "../models/IUser";
import { isMobile } from 'react-device-detect';

const AppPage = () => {
/*
    const token = new URLSearchParams((location.search ? location.search : "").toLowerCase()).get("token".toLowerCase());
    const refreshToken = new URLSearchParams((location.search ? location.search : "").toLowerCase()).get("refreshToken".toLowerCase());
    console.log("token", token);
    console.log("refreshToken", refreshToken);
    if (token) {
        localStorage.setItem("token", token);
    }
    if (refreshToken) {
        localStorage.setItem("refreshToken", refreshToken);
    }
*/

    const authStore: AuthStore = useAuthStore();
    const extractAuthInfoFromQuery = (): boolean => {
        const authInfoStr = new URLSearchParams((location.search ? location.search : "")).get("authInfo");
        try {
            const authInfo = JSON.parse(authInfoStr);
            console.log("authInfo", authInfo);
            if (authInfo) {
                authStore.setAuthInfoAuthStore(authInfo);
                return true;
            }
        }
        catch {
        }
        return false;
    }

    const checkAuth = () => {
        if (!extractAuthInfoFromQuery()) {
//            if (localStorage.getItem("token"))
            {
                authStore.checkAuth();
            }
        }
    }
    React.useEffect(() => {
        checkAuth()
    }
        , []
    )
    authStore.storage["useTabPanel"] = true;
    return (
        <BrowserRouter>
            <MainApp
            />
        </BrowserRouter>
    )
}
export default observer(AppPage);
